module.exports = __webpack_public_path__ + "static/banner-design-d371f729b8becd1a9311f954d247ae47.png";